// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-showcase {
  padding-left: var(--spacing-regular);
  padding-right: var(--spacing-regular);
}
.container-title-breadcrumb {
  padding-top: var(--spacing-small);
  padding-bottom: var(--spacing-extra-big);
}
.container-title {
  padding-top: var(--spacing-extra-big);
}
.text-title {
  font-size: var(--font-giant);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.container-products-not-found {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.icon-search-not-found {
  margin-bottom: var(--spacing-regular);
  transform: scale(2);
}
.icon-search-not-found span svg {
  fill: var(--color-neutral-dark) !important;
}
.text-search-not-found {
  font-size: var(--font-giant);
  font-weight: 600;
  color: var(--color-neutral-dark);
}
.text-align-center {
  text-align: center;
}
.main-container-showcase {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.container-loading {
  text-align: center;
}
.container-items-showcase {
  margin-bottom: var(--spacing-small);
}
.box-showcase-item .vert-template-marketplace.vert-card-product.ant-card > .ant-card-body .vert-card-product-actions .vert-card-product-actions-inner,
.box-showcase-item .vert-template-marketplace .vert-card-product.ant-card > .ant-card-body .vert-card-product-actions .vert-card-product-actions-inner {
  min-height: 85px;
}
@media (min-width: 576px) and (max-width: 768px) {
  .box-showcase-item .vert-template-marketplace.vert-card-product.ant-card > .ant-card-body .vert-card-product-actions .vert-card-product-actions-inner,
  .box-showcase-item .vert-template-marketplace .vert-card-product.ant-card > .ant-card-body .vert-card-product-actions .vert-card-product-actions-inner {
    min-height: 65px;
  }
}
@media (min-width: 320px) and (max-width: 375px) {
  .box-showcase-item .vert-template-marketplace.vert-card-product.ant-card > .ant-card-body .vert-card-product-actions .vert-card-product-actions-inner,
  .box-showcase-item .vert-template-marketplace .vert-card-product.ant-card > .ant-card-body .vert-card-product-actions .vert-card-product-actions-inner {
    min-height: 84px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/showcase/ShowcaseStyles.less"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,qCAAA;AACF;AAEA;EACE,iCAAA;EACA,wCAAA;AAAF;AAGA;EACE,qCAAA;AADF;AAIA;EACE,4BAAA;EACA,gBAAA;EACA,gCAAA;AAFF;AAKA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;AAMA;EACE,qCAAA;EACA,mBAAA;AAJF;AAEA;EAMM,0CAAA;AALN;AAUA;EACE,4BAAA;EACA,gBAAA;EACA,gCAAA;AARF;AAWA;EACE,kBAAA;AATF;AAYA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAVF;AAaA;EACE,kBAAA;AAXF;AAcA;EACE,mCAAA;AAZF;AAeA;;EAUI,gBAAA;AArBJ;AAyBA;EACE;;IAUI,gBAAA;EA/BJ;AACF;AAkCA;EACE;;IAUI,gBAAA;EAxCJ;AACF","sourcesContent":[".container-showcase {\n  padding-left: var(--spacing-regular);\n  padding-right: var(--spacing-regular);\n}\n\n.container-title-breadcrumb {\n  padding-top: var(--spacing-small);\n  padding-bottom: var(--spacing-extra-big);\n}\n\n.container-title {\n  padding-top: var(--spacing-extra-big);\n}\n\n.text-title {\n  font-size: var(--font-giant);\n  font-weight: 600;\n  color: var(--color-neutral-dark);\n}\n\n.container-products-not-found {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.icon-search-not-found {\n  margin-bottom: var(--spacing-regular);\n  transform: scale(2);\n\n  span {\n    svg {\n      fill: var(--color-neutral-dark) !important;\n    }\n  }\n}\n\n.text-search-not-found {\n  font-size: var(--font-giant);\n  font-weight: 600;\n  color: var(--color-neutral-dark);\n}\n\n.text-align-center {\n  text-align: center;\n}\n\n.main-container-showcase {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.container-loading {\n  text-align: center;\n}\n\n.container-items-showcase {\n  margin-bottom: var(--spacing-small);\n}\n\n.box-showcase-item {\n  .vert-template-marketplace.vert-card-product.ant-card\n    > .ant-card-body\n    .vert-card-product-actions\n    .vert-card-product-actions-inner,\n  .vert-template-marketplace\n    .vert-card-product.ant-card\n    > .ant-card-body\n    .vert-card-product-actions\n    .vert-card-product-actions-inner {\n    min-height: 85px;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 768px) {\n  .box-showcase-item {\n    .vert-template-marketplace.vert-card-product.ant-card\n      > .ant-card-body\n      .vert-card-product-actions\n      .vert-card-product-actions-inner,\n    .vert-template-marketplace\n      .vert-card-product.ant-card\n      > .ant-card-body\n      .vert-card-product-actions\n      .vert-card-product-actions-inner {\n      min-height: 65px;\n    }\n  }\n}\n@media (min-width: 320px) and (max-width: 375px) {\n  .box-showcase-item {\n    .vert-template-marketplace.vert-card-product.ant-card\n      > .ant-card-body\n      .vert-card-product-actions\n      .vert-card-product-actions-inner,\n    .vert-template-marketplace\n      .vert-card-product.ant-card\n      > .ant-card-body\n      .vert-card-product-actions\n      .vert-card-product-actions-inner {\n      min-height: 84px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
